export const CitationWidgetId = 'citation-widget'
